// @flow
import { createRef, useState } from "react";
import {
  Heading,
  QuestionWrapper,
  RadioButtons,
  type RadioButtonsOptions,
} from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const validate = validatePresence("urgency", "Please select an option");

export const options: RadioButtonsOptions<CustomerUrgencyValue> = [
  {
    value: "LESS_THAN_THREE_MONTHS",
    label: "In the next 3 months",
  },
  {
    value: "THREE_TO_SIX_MONTHS",
    label: "In 3-6 months",
  },
  {
    value: "SIX_MONTHS_PLUS",
    label: "In 6+ months",
  },
];

type Props = {
  ...QuestionProps<"urgency">,
  initialModalOpen?: boolean,
};

export const UrgencyComponent = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: Props) => {
  const [urgency, setUrgency] = useState(initialValue);

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <QuestionWrapper
      next={() => next(urgency, validate)}
      dataTest="urgency-question"
    >
      <BackButton />
      <Heading>When are you thinking of selling?</Heading>
      <RadioButtons
        errorMessage={validationErrors.urgency}
        hasErrors={!valid}
        name="urgency"
        onChange={(value) => setUrgency(value)}
        options={options}
        ref={ref}
        value={urgency}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
